import React, { Fragment } from "react";

import { Container, NPSLabel } from "./styles";
import { colors } from "../../../../styles";
import { Input } from "../../../../styles/defaults";

const npsColors = [
  colors.npsZero,
  colors.npsOne,
  colors.npsTwo,
  colors.npsThree,
  colors.npsFour,
  colors.npsFive,
  colors.npsSix,
  colors.npsSeven,
  colors.npsEight,
  colors.npsNine,
  colors.npsTen
];

function NPS({ response, onValueChange, onClick, guid, questionIndexToModel }) {
  return (
    <Container>
      {npsColors.map((color, index) => (
        <Fragment key={`${questionIndexToModel}-${index}-${guid}`}>
          <Input
            type="radio"
            value={index}
            id={`${questionIndexToModel}-${index}-${guid}`}
            name="net-promoter-score"
            onChange={({ target }) =>
              onValueChange({ response: parseInt(target.value) })
            }
            defaultChecked={parseInt(response) === index}
            onClick={({ target }) => onClick(target.value)}
          />
          <NPSLabel
            checked={parseInt(response) === index}
            selected={response}
            bgColor={color}
            htmlFor={`${questionIndexToModel}-${index}-${guid}`}
          >
            {index}
          </NPSLabel>
        </Fragment>
      ))}
    </Container>
  );
}

export default NPS;
